import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  height: 100vh;
  padding: 0;

  @media (max-height: 700px) and (min-width: 700px), (max-width: 360px) {
    height: auto;
    padding-top: var(--nav-height);
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 5px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: auto;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, my name is</h1>;
  const two = <h2 className="big-heading">Ayesha Najam.</h2>;
  const three = <h3 className="big-heading">Driven by Design Precision.</h3>;
  const four = (
    <>
      <p>
      Hi, I’m Ayesha Najam, A passionate and detail-oriented UI/UX Designer with a BFA in Graphic Design. I specialize in creating user-centric digital experiences that combine creativity with data-driven insights.
      </p>
      <p>
      With expertise in tools like Figma, Sketch, and Adobe XD, I excel in crafting accessible, impactful designs that drive user engagement and align with business goals. Adept at collaborating within Agile environments, I bring precision, innovation, and a commitment to delivering exceptional results to every project
      </p>
    </>
  );

  const five = (
    <div style={{ display: 'flex', gap: '10px' }}>
      <a
        className="email-link"
        href="https://www.linkedin.com/in/ayesha-najam1/"
        target="_blank"
        rel="noreferrer">
        LinkedIn
      </a>
      <a
        className="email-link"
        href="https://www.behance.net/ayeshanajam"
        target="_blank"
        rel="noreferrer">
        Behance
      </a>
    </div>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
